import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { onDownloadProgress } from "@/lib/api";

export const DownloadProgressBar = () => {
  const [s, setS] = useState({ active: false, percent: null, label: "" });
  useEffect(() => onDownloadProgress(setS), []);
  if (!s.active) return null;
  const indeterminate = s.percent == null;
  const verb = s.mode === "up" ? "Uploading" : "Downloading";
  return (
    <div className="fixed inset-x-0 top-0 z-[100]" data-testid="download-progress">
      <div className="h-1 w-full overflow-hidden bg-slate-200/70">
        {indeterminate
          ? <div className="h-full w-2/5 animate-[dlslide_1.1s_ease-in-out_infinite] bg-[#E63946]" />
          : <div className="h-full bg-[#E63946] transition-[width] duration-200" style={{ width: `${s.percent}%` }} />}
      </div>
      <div className="flex justify-center">
        <div className="mt-1 flex max-w-[90vw] items-center gap-2 rounded-b-sm bg-slate-900 px-3 py-1 text-xs text-white shadow" data-testid="download-progress-label">
          <Download size={12} className="shrink-0" />
          <span className="truncate">{verb}{s.label ? ` ${s.label}` : "…"}</span>
          {!indeterminate && <span className="font-semibold">· {s.percent}%</span>}
        </div>
      </div>
      <style>{`@keyframes dlslide{0%{transform:translateX(-120%)}100%{transform:translateX(320%)}}`}</style>
    </div>
  );
};
